import React, { createContext, useContext, ReactNode } from 'react';
import { useMessageOperations, MessageOperations } from '../hooks/useMessageOperations';
import { useChatContext } from './AppDataContext';

// Create a context with a default value
const MessageOperationsContext = createContext<MessageOperations | undefined>(undefined);

// Provider component
export const MessageOperationsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { messages, setMessages } = useChatContext();
  const messageOperations = useMessageOperations(messages, setMessages);

  return (
    <MessageOperationsContext.Provider value={messageOperations}>
      {children}
    </MessageOperationsContext.Provider>
  );
};

// Custom hook to use the message operations context
export const useMessageOperationsContext = (): MessageOperations => {
  const context = useContext(MessageOperationsContext);
  if (context === undefined) {
    throw new Error('useMessageOperationsContext must be used within a MessageOperationsProvider');
  }
  return context;
}; 